"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSNavigationSubMenu = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxRuntime classic */
/** @jsx jsx */
var react_1 = require("@emotion/react");
var Theme_1 = require("../../../../Theme");
var BDSNavigationSubMenu_style_1 = require("./BDSNavigationSubMenu.style");
var BDSNavigationSubMenu = function (props) {
    var theme = Theme_1.lightTheme;
    var themeCss = react_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), theme.colors.bg1);
    return (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "sub-button-panel " + (props.active ? 'active' : ''), style: props.style || {}, css: [BDSNavigationSubMenu_style_1.baseCss, themeCss] }, { children: jsx_runtime_1.jsx("button", tslib_1.__assign({ type: "button", onClick: function (e) {
                e.stopPropagation();
                if (props.handleOnClick) {
                    props.handleOnClick();
                }
            } }, { children: props.label }), void 0) }), void 0));
};
exports.BDSNavigationSubMenu = BDSNavigationSubMenu;
var templateObject_1;
